/**
 * @Description 选址地图详情分享按钮
 */

import { FC } from 'react';
import { Tooltip } from 'antd';
import { useMethods } from '@lhb/hook';
import { getShareId } from '@/common/api/common';
import { getCookie } from '@lhb/cache';
// import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import dayjs from 'dayjs';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import copy from 'copy-to-clipboard';
import { getSiteModelList } from '@/common/api/networkplan';

interface ShareProps {
  id: number;
  modelConfigId: number;
  globalAliasItemVOs: any;
  tenantInfo: any;
  // userInfo: any;
  userId: any;
  // isSemirModel: boolean;
};

const Share: FC<ShareProps> = ({
  id,
  modelConfigId,
  globalAliasItemVOs = {},
  tenantInfo = {}, // 租户信息
  userId,
  // isSemirModel,
}) => {
  const { standardChancePointReportLogo: reportLogo } = tenantInfo;

  const methods = useMethods({
    handleShare: async() => {
      let targetModelConfigId = modelConfigId;
      if (!targetModelConfigId || +targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = data[0]?.id || 0;
      }
      // 兜底，防止机会点所属商圈组件、新增商圈列表页在引用该详情时，没有配置选址地图模型
      if (!targetModelConfigId) {
        V2Message.warning(`请先配置选址地图模型！`);
        return;
      }

      const curTime = dayjs();
      const failureTime = curTime.add(7, 'day').format('YYYY-MM-DD HH:mm:ss');
      const tenantId = getCookie('tenantId') || tenantInfo?.id;
      const employeeId = getCookie('employeeId') || userId;

      getShareId({
        longLinkUrl: `${process.env.CONSOLE_PC_URL}/share/siteselectionmapb`,
        content: JSON.stringify({ id, modelConfigId: targetModelConfigId, tenantId, globalAliasItemVOs, reportLogo, failureTime, employeeId,
          // isSemirModel
        }),
        expirationDate: failureTime,
        expirationRedirectUrl: `${process.env.CONSOLE_PC_URL}/share/failure`,
      }).then((res: any) => {
        V2Message.success('链接已复制，可直接发送给你的朋友');
        // https://gitlab.lanhanba.com/fe/treasure/-/issues/102
        setTimeout(() => {
          copy(res.frontShareLinkUrl);
        }, 0);
      });
    }
  });
  return (
    <Tooltip title='分享'>
      <div className={styles.shareCon} onClick={methods.handleShare}>
        <IconFont iconHref='iconshare'/>
      </div>
    </Tooltip>

  );
};

export default Share;
